import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet, useNavigate, useLocation } from "react-router-dom";
import Login from "../login/login";
import "./demo.css";
import Upload_ot from '../OMS/online_order_management/Upload_ot';
import MainRouteQueueManagemet from '../queue_management/main_route';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import { Mainlayout } from './../ui/ot'
import RouteOrganizationStructure from './../../components/organization_structure/MainRoute';
import NavBrandBackend from './../../theme/layout_backend2'
import Signup from '../queue_management/views/signup';
import { useRef } from 'react';
import { useCRUDController } from '../ui/classify_structure/CRUDController';
import { useEffect } from 'react';
import { useState } from 'react';
import AreaManagement from './../queue_management/views/area_management'
import ShiftManagement from './../reservation_registration_and_space_management/views/schedule_management'

const RouteEducation = ({
    admin = true
}) => {
    const mobile = localStorage?.getItem('mobile') || 'true';
    const menuData = [
        {
            label: "使用者管理",
            children: [
                {
                    key: "/organization_structure/structure",
                    label: "單位結構設定",
                },
                {
                    key: "/organization_structure/role",
                    label: "角色身份設定",
                },
                {
                    key: "/organization_structure/staff_role",
                    label: "人員基本資料設定",
                },
            ],
        },
        {
            label: "人員審核",
            key: "/queue_management/nature_person"
        },
        {
            label: "校外人士進館前台統計",
            key: "/queue_management"
        },
        {
            label: "校外人士預約",
            key: "/queue_management/queue_management_self"
        },
        {
            label: "校外人士進館後台管理",
            key: "/queue_management/queue_management"
        },
        {
            label: "校外人士進館",
            key: "/queue_management/area_management"
        },
    ]

    return (<>
        <Helmet>
            {mobile === 'true' &&
                <meta name="viewport" content="width=device-width, initial-scale=1" />
            }
        </Helmet>
        <BrowserRouter>
            <Routes>
                <Route path={'upload'}>
                    {/* <Route index element={<Login logo="OT" />} /> */}
                    <Route index element={<Upload_ot />} />
                </Route>
                <Route path={'login'}>
                    <Route index element={
                        <Login onChangeLanguage={() => { }} logo="AI" footerCopyRight="人工智慧研發產學中心"
                            setting={{
                                webSites: false,
                                forgotPassword: false,
                                forgotAccount: false,
                                lineLogin: false,
                                signAccount: true,
                                rememberMe: true,
                                language: false,
                                chatting: false,
                            }}
                            defaultLogoInURL={null}
                            customSignup={<Signup />}
                        />
                    }
                    />
                </Route>
                <Route path={'signup'}>
                    <Route index element={<Signup />}>
                    </Route>
                </Route>
                <Route index element={<Navigate to={admin ? "/queue_management/queue_management" : "/queue_management/queue_management_self"} />} />
                <Route path={''} element={<JWT />}>
                    <Route path={'queue_management'} element={<AreaManagement admin={false} key={''} propsLoading={false} propsSetLoading={() => { }} />} />
                    <Route path={'/'} element={<MainOutlet />}>
                        <Route path={'/queue_management/*'} element={<MainRouteQueueManagemet admin={admin} />}>{/* true是要登入的 false是只會剩下形象的前台 */}
                        </Route>
                        <Route path={''}>
                            <Route path="" element={<Mainlayout />}>
                                <Route path={'organization_structure/*'} element={<RouteOrganizationStructure />}>
                                </Route>
                            </Route>
                        </Route>
                    </Route>
                </Route>
            </Routes>
        </BrowserRouter>
    </>);
}
export default RouteEducation;

const JWT = () => {
    axios.interceptors.request.use(
        async (config) => {
            const access_token = localStorage.getItem("access_token");

            if (access_token) {
                config.headers = {
                    ...config.headers,
                    authorization: `Bearer ${access_token}`,
                };
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        function (error) {
            const access_token_url = "/access_token";
            const config = error.config;
            if (error.response?.status === 401 && config.url === access_token_url) {
                window.location.href = "/login";
                return Promise.reject(error);
            }

            if (error.response?.status === 401 && !config._retry) {
                config._retry = true;
                const refreshToken = localStorage.getItem("refresh_token");
                return axios
                    .post(access_token_url, {
                        refresh_token: refreshToken,
                    })
                    .then((res) => {
                        if (res?.status === 201) {
                            localStorage.setItem("access_token", res.data.access_token);
                            config.headers = {
                                ...config.headers,
                                authorization: `Bearer ${localStorage.getItem("access_token")}`,
                            };
                            return axios(config);
                        }
                    });
            }
            return Promise.reject(error);
        }
    );
    return <Outlet />;
};


const MainOutlet = () => {

    const navigate = useNavigate()

    const needReload = useRef(false)
    const { ResponseData: StaffDivergeSelfData, getData: getStaffDivergeSelfData } = useCRUDController({
        apiRoute: '/organization_structure/api/staff_diverge_self'
    })
    const backendMenuData = [
        {
            label: "校外人士進館預約",
            key: "/queue_management/queue_management_self"
        },
        ...(StaffDivergeSelfData?.find(_ => true)?.permission_data_all ?? StaffDivergeSelfData?.find(_ => true)?.permission_data ?? []).map(item => {
            return {
                label: item?.permission_group_name,
                children: item?.permission_data?.map(itemItem => (
                    {
                        label: itemItem?.permission_name,
                        key: itemItem?.url,
                    }
                ))
            }
        }),
        {
            key: "/queue_management",
            label: "校外人士進館統計",
        },
    ]

    const location = useLocation()
    const [userPermissionData, setUserPermissionData] = useState(null)
    const getStaffDiverge = () => {
        const access_token = localStorage.getItem("access_token");
        axios
            .get('/organization_structure/api/staff_diverge_self', {
                headers: {
                    authorization: `Bearer ${access_token}`,
                }
            })
            .then((response) => {
                let data = response.data?.data || []
                let first_data = data.find(ele => true)
                setUserPermissionData(first_data?.user_role_permission_data ?? first_data?.user_permission_data)
            })
            .finally(() => {
            })
    }

    const HasPermission = ({ locationPathname, permissions }) => {
        let hasPermission = permissions.find((element) => {
            const regex = new RegExp(`^${element?.permission_url}(\/\\d+)?$`);

            const isMatch = regex.test(locationPathname);
            return isMatch
        })
        if (!hasPermission
            && String(locationPathname).toLowerCase() !== "/"
            && String(locationPathname).toLowerCase() != String('/organization_structure/depth').toLowerCase()
            && String(locationPathname).toLowerCase() != String('/organization_structure/noPermission').toLowerCase()
            && String(locationPathname).toLowerCase() != String('/queue_management').toLowerCase()
            && String(locationPathname).toLowerCase() != String('/queue_management/queue_management_self').toLowerCase()
        ) {
            navigate('/organization_structure/noPermission')
        }

    }

    useEffect(() => {
        if (!!userPermissionData) {
            HasPermission({ locationPathname: location?.pathname, permissions: userPermissionData })
        }
    }, [userPermissionData])
    useEffect(() => {
        if (!!userPermissionData) {
            HasPermission({ locationPathname: location?.pathname, permissions: userPermissionData })
        }
        if (needReload.current === true) {
            getStaffDiverge()
            getStaffDivergeSelfData()
        }
        if (location?.pathname === "/organization_structure/permission_management") {
            needReload.current = true
        }
        else {
            needReload.current = false
        }

    }, [location])
    useEffect(() => {
        getStaffDiverge()
        getStaffDivergeSelfData()
    }, []);
    return <>
        <NavBrandBackend prefixTitle='高師大圖書館' menuData={backendMenuData} />
    </>
}